import React from 'react';

const LoadMore = (props) => {

    const handleClick = () => {
        props.onClick()
      }

    return(
        <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center',margin: '10px auto 0px auto', paddingBottom: '20px'}}>
            <button style={{boxSizing: 'border-box', fontSize: '12px', width: '120px', height: '30px', textAlign: 'center', border: `2px solid ${props.borderColor}`, outline: 'none', fontWeight: 700, borderRadius: '5px', padding: '3px 0px 3px 0px', backgroundColor: props.buttonColor, color: props.textColor, textTransform: 'uppercase', letterSpacing: '0.25px', transition: 'all 0.3s ease 0s'}} onClick={handleClick}>
                {props.buttonText || 'Load More'}
            </button> 
        </div>
    )

};

export default LoadMore;